export default __webpack_public_path__ + "static/media/login_banner_img.54379418.png";